module.exports = __webpack_public_path__ + "static/media/elipse-tour.841a344e.png";